<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-success opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <h1 class="display-2 text-white font-size-20">
              <span class="text-white"
                >Olá,
                <span class="text-warning d-inline">{{
                  model.startup.name
                }}</span
                >! :)</span
              >
            </h1>
            <p class="text-white mt-4 mb-2">
              Aqui você pode conferir a atualizar as informações básicas de sua
              conta. Além disso, você também pode modificar a logo da startup e
              alterar sua senha de usuário.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
          <div class="card card-profile shadow vld-parent" ref="startup_logo">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <img :src="getStartupLogoPath" />
                </div>
              </div>
            </div>
            <div
              class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
            ></div>
            <div class="card-body pt-0 pt-md-4 pb-0">
              <div class="row">
                <div class="col">
                  <div class="text-center mt-6">
                    <h2 class="text-orange">
                      {{ model.startup.name }}
                    </h2>
                    <div class="h5 font-weight-300">
                      <i class="ni ni-pin-3 mr-2"></i
                      >{{ model.startup.city || "..." }},
                      {{ model.startup.state || "..." }}
                    </div>
                    <div>
                      <div class="h5 font-weight-300 mb-1">
                        <i class="fas fa-envelope mr-2"></i>
                        {{ model.startup.email }}
                      </div>
                    </div>
                    <div class="h5 mt-2">
                      <badge
                        type="info"
                        v-for="sector in model.startup.sector"
                        :key="'badge_' + sector"
                      >
                        {{ sector }}
                      </badge>
                    </div>
                    <hr class="mt-3 mb-4" />
                    <div class="row">
                      <div class="col">
                        <file-select
                          v-model="model.startupLogo"
                          title="Selecione o logo da startup"
                          accept="image/*"
                          :mbSize="2"
                        ></file-select>
                        <button
                          v-if="model.startupLogo"
                          @click="handleSubmitLogo"
                          class="btn btn-primary my-2 jump"
                        >
                          Salvar arquivo
                        </button>
                      </div>
                    </div>
                    <p class="text-sm text-muted">
                      <i class="fas fa-info-circle mr-1"></i> O logo da startup
                      deve possuir tamanho máximo de 2MB e, preferenciamente,
                      ser do formato <b>PNG</b> ou <b>JPG</b> com dimensão de
                      <b>500x500 pixels</b>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-8 order-xl-1">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Meu perfil</h3>
                </div>
                <div class="col-4 text-right">
                  <span class="btn btn-sm btn-primary">Edição</span>
                </div>
              </div>
            </div>
            <template>
              <form role="form" class="vld-parent" ref="startup_form">
                <div class="row ml-1">
                  <h6 class="heading-small text-muted mb-4">
                    Informações básicas
                  </h6>
                </div>
                <div class="row ml-2">
                  <div class="col">
                    <base-input
                      label="Nome da startup"
                      v-model="model.startup.name"
                      placeholder="Digite o nome de sua startup"
                    />
                    <base-input
                      label="Data de fundação"
                      type="date"
                      v-model="model.startup.foundation"
                      placeholder="Selecione"
                    />
                    <estados
                      estadoLabel="Estado da startup"
                      cidadeLabel="Cidade da startup"
                      :selectedEstado="model.startup.state"
                      :selectedCidade="model.startup.city"
                      @inputEstado="handleStateChange"
                      @inputCidade="handleCityChange"
                    />
                    <div class="row">
                      <div
                        v-show="originalLocation.show"
                        class="col text-sm text-right"
                      >
                        <i class="ni ni-pin-3 mr-1"></i> Localização original:
                        {{ local() }}.
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="my-4" />
                <div class="row ml-1">
                  <h6 class="heading-small text-muted mb-4">
                    Informações do negócio
                  </h6>
                </div>
                <div class="row ml-2">
                  <div class="col-lg-12">
                    <div class="form-group has-label">
                      <base-input
                        label="Definição sucinta do seu negócio em uma única frase (one-line pitch)"
                      >
                        <textarea
                          rows="2"
                          v-model="model.startup.one_sentence_pitch"
                          class="form-control"
                          placeholder="Uma ou duas linhas devem ser o suficiente :)"
                        >
                        </textarea>
                      </base-input>
                      <label class="form-control-label"
                        >Em qual(is) setor(es) econômico(s) sua startup atua?
                        Você pode informar mais de uma opção.</label
                      >
                      <v-select
                        :components="{ OpenIndicator }"
                        class="sector_select"
                        multiple
                        placeholder="Busque por um setor"
                        label="name"
                        :options="sectors"
                        v-model="model.startup.sector"
                        :closeOnSelect="false"
                      >
                        <template v-slot:option="option">
                          <div class="row">
                            <div class="col-12 text-left">
                              <span>{{ option.name }}</span>
                            </div>
                          </div>
                        </template>
                        <span slot="no-options">Nenhuma opção disponível</span>
                      </v-select>
                      <div v-if="model.startup.sector.includes('Outro')">
                        <base-input
                          label="Escreva o nome do setor para substituir Outro"
                          v-model="customSector"
                          placeholder="Digite o nome do setor"
                        />
                        <base-button @click="handleAddCustomSector()"
                          >Adicionar</base-button
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      label="Em qual mercado principal sua startup pretende atuar?"
                    >
                      <select
                        class="form-control"
                        v-model="model.startup.bussiness_strategy"
                      >
                        <option value="" selected disabled>
                          Selecione uma opção
                        </option>
                        <option
                          v-for="option in bussinesModels"
                          :key="option"
                          :value="option"
                        >
                          {{ option }}
                        </option>
                      </select>
                    </base-input>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group has-label">
                      <label class="form-control-label"
                        >Qual estágio a startup está atualmente?</label
                      >
                      <select
                        class="form-control"
                        v-model="model.startup.stage"
                      >
                        <option value="" selected disabled>
                          Selecione uma opção
                        </option>
                        <option
                          v-for="stage in Object.keys(stages)"
                          :key="'stage_' + stage"
                          :value="stage"
                        >
                          {{ stages[stage] }}
                        </option>
                      </select>
                      <div v-if="model.startup.stage === 'other'">
                        <label
                          style="font-size: 11px; margin-left: 10px"
                          class="form-control-label"
                          >Especifique:</label
                        >
                        <base-input
                          style="font-size: 11px; margin-left: 10px"
                          v-model="stagesOtherText"
                          placeholder="Digite aqui o nome que identifica o estágio"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row ml-2">
                  <div class="col-12 text-center" v-if="error">
                    <base-alert type="danger">{{ error }}</base-alert>
                  </div>
                  <div class="col-12 text-center" v-if="success">
                    <base-alert type="success">{{ success }}</base-alert>
                  </div>
                </div>
                <div class="text-right">
                  <base-button
                    type="primary"
                    :custom="true"
                    @click="handleSubmitForm"
                    >Salvar alterações</base-button
                  >
                </div>
                <hr class="my-4" />
                <div class="col-12 ml-1">
                  <h6 class="heading-small text-muted">
                    Detalhes da conta - Segurança
                    <base-button
                      type="dark"
                      size="sm"
                      class="float-right mt-4 mt-md--1 mt-sm--1"
                      @click="handleOpenModalChangePassword"
                      ><i class="fas fa-lock mr-2"></i> Modificar
                      senha</base-button
                    >
                  </h6>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.modalChangePassword"
      modal-classes="modal-dialog-centered"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_change_password">
        <div class="py-3 text-center">
          <i class="fas fa-key fa-3x"></i>
          <h4 class="heading mt-4">Modificar senha</h4>
        </div>
        <div class="py-3 text-center">
          <base-input
            type="password"
            placeholder="Senha antiga"
            addon-left-icon="ni ni-lock-circle-open"
            v-model="model.user.oldPassword"
          >
          </base-input
          ><base-input
            type="password"
            placeholder="Nova senha"
            addon-left-icon="ni ni-lock-circle-open"
            v-model="model.user.newPassword"
          >
          </base-input
          ><base-input
            type="password"
            placeholder="Confirmar nova senha"
            addon-left-icon="ni ni-lock-circle-open"
            v-model="model.user.newPasswordConfirmation"
          >
          </base-input>
          <p
            class="text-right mb-0"
            v-show="
              model.user.newPassword &&
              model.user.newPasswordConfirmation &&
              !newPasswordInputsMatch()
            "
          >
            <small>As senhas não conferem!</small>
          </p>
        </div>
        <div class="text-center" v-if="modals.modalError">
          <base-alert type="danger">{{ modals.modalError }}</base-alert>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="dark"
          class="ml-auto"
          @click="modals.modalChangePassword = false"
        >
          Voltar
        </base-button>
        <base-button
          type="default"
          :disabled="!newPasswordInputsMatch()"
          @click="handleSubmitChangePassword()"
        >
          Alterar senha
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api.js";
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";

export default {
  name: "startup-profile",
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      model: {
        startup: {
          name: "",
          sector: [],
          foundation: "",
          stage: "",
          bussiness_strategy: "",
          state: "",
          city: "",
          one_sentence_pitch: "",
          // how_meet_stars: "",
          logo: null,
        },
        startupLogo: null,
        user: {
          oldPassword: "",
          newPassword: "",
          newPasswordConfirmation: "",
        },
      },
      stages: {
        concept: "Ideação",
        validation: "Validação",
        traction: "Tração",
        scale: "Escala",
        other: "Outro",
      },
      customSector: "",
      stagesOtherText: "",
      bussinesModels: [
        "Business to Business (B2B)",
        "Business to Consumer (B2C)",
        "Business to Business + Business to Consumer (B2B+B2C)",
        "Business to Government (B2G)",
        "Consumer to Consumer (C2C)",
        "Outros",
      ],
      sectors: [
        "Aeroespacial",
        "Agricultura",
        "Agtech",
        "Alimentos e bebidas",
        "Biotecnologia",
        "Computadores e periféricos",
        "Construção",
        "Consultoria",
        "Dispositivos e equipamentos médicos",
        "Edtech",
        "Educação",
        "Eletrônica/instrumentação",
        "Esportes",
        "Estilo de vida",
        "Imóveis",
        "Fintech",
        "Foodtech",
        "Healthtech",
        "Indústria/energia",
        "Internet/serviços da web",
        "Jogos",
        "Jurídico",
        "Legaltech",
        "Logtech",
        "Marketing digital",
        "Marketing/publicidade",
        "Marítimo",
        "Mineração",
        "Moda",
        "Mídias e entretenimento",
        "Nanotecnologia",
        "Náutica/Navegação",
        "Petróleo e gás",
        "Produtos da empresa",
        "Produtos de consumo",
        "Redes e equipamentos",
        "Retailtech",
        "Robótica",
        "Segurança",
        "Semicondutores",
        "Serviços a empresas",
        "Serviços ao consumidor",
        "Serviços de saúde",
        "Serviços de TI",
        "Serviços financeiros",
        "Serviços móveis",
        "Software",
        "Substâncias e produtos químicos",
        "Tecnologia limpa",
        "Tecnologia para finanças",
        "Telecomunicações",
        "Transportes",
        "Turismo",
        "Varejo/distribuição",
        "Outro",
      ],
      modals: {
        modalChangePassword: false,
        modalError: "",
      },
      error: "",
      success: "",
      originalLocation: {
        show: false,
        state: "",
        city: "",
      },
      OpenIndicator: {
        render: (createElement) =>
          createElement("i", { class: { "toggle fas fa-search": true } }),
      },
    };
  },
  async mounted() {
    const loaderForm = this.$loading.show({
      container: this.$refs.startup_form,
      width: 90,
      height: 90,
    });
    const loaderLogo = this.$loading.show({
      container: this.$refs.startup_logo,
      width: 130,
      height: 130,
    });
    try {
      const { data } = await api.get("/startups");
      if (!Object.keys(this.stages).includes(data.stage)) {
        this.stagesOtherText = data.stage;
        data.stage = "other";
      }
      data.sector = data.sector.split(",");

      const { how_meet_stars, ...startup } = data;
      Object.assign(this.model.startup, startup);

      console.log(this.model.startup);
      this.originalLocation.state = data.state;
      this.originalLocation.city = data.city;
      loaderForm.hide();
      loaderLogo.hide();
    } catch (e) {
      this.error =
        "Ocorreu um erro ao recuperar as informações de perfil do usuário.";
      this.$toasted.error("Erro ao recuperar as informações");
    }
  },
  methods: {
    async handleSubmitForm(e) {
      e.preventDefault();
      this.error = this.success = "";
      const startupData = this.model.startup;
      console.log(startupData);
      for (const key in startupData) {
        if (startupData[key] === "") {
          console.log(`Campo ${key} não preenchido`);
          this.error =
            "Por favor, preencha todos os campos obrigatórios antes de continuar.";
          return;
        }
      }
      const loader = this.$loading.show({
        container: this.$refs.startup_form,
        width: 90,
        height: 90,
      });
      try {
        const stage = this.model.startup.stage;
        const { data } = await api.put(
          `/startups/${this.model.startup.user_id}`,
          {
            ...startupData,
            sector: this.model.startup.sector.toString(),
            stage: stage !== "other" ? stage : this.stagesOtherText,
          }
        );
        this.originalLocation.state = data.state;
        this.originalLocation.city = data.city;
        this.$toasted.show("Informações atualizadas com sucesso");
        this.success = "Perfil atualizado com sucesso!";
      } catch (e) {
        this.error =
          "Não foi possível salvar as informações. Por favor, tente novamente em alguns instantes.";
        this.$toasted.error("Ocorreu um erro ao salvar as informações");
      }
      loader.hide();
    },
    async handleSubmitLogo() {
      this.error = this.success = "";
      const loader = this.$loading.show({
        container: this.$refs.startup_logo,
        width: 130,
        height: 130,
        opacity: 0,
      });
      const logo = this.model.startupLogo;
      if (!logo) return;
      const data = new FormData();
      data.append("logo", logo, logo.name);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      try {
        await api.post(
          `/startups/${this.model.startup.user_id}/logos`,
          data,
          config
        );
        this.$toasted.show("Logo salvo com sucesso");
        const { data: logoData } = await api.get(
          `/startups/${this.model.startup.user_id}/logos`
        );
        if (logoData) this.model.startup.logo = logoData;
        this.model.startupLogo = null;
        this.success = "Logo atualizado com sucesso!";
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao salvar o logo");
        this.error =
          "Não foi possível alterar o logo. Por favor, tente novamente em alguns instantes.";
      }
      loader.hide();
    },
    local() {
      return `${this.originalLocation.city}, ${this.originalLocation.state}`;
    },
    handleStateChange(newState) {
      this.model.startup.state = newState;
      this.originalLocation.show = true;
    },
    handleCityChange(newCity) {
      this.model.startup.city = newCity;
      this.originalLocation.show = true;
    },
    handleOpenModalChangePassword() {
      this.model.user.oldPassword = "";
      this.model.user.newPassword = "";
      this.model.user.newPasswordConfirmation = "";
      this.modals.modalChangePassword = true;
      this.modals.modalError = "";
    },
    handleAddCustomSector() {
      if (this.customSector) {
        this.model.startup.sector = this.model.startup.sector.filter(
          (sector) => sector !== "Outro"
        );
        this.model.startup.sector.push(this.customSector);
        this.customSector = "";
      }
    },
    newPasswordInputsMatch() {
      if (
        this.model.user.newPassword &&
        this.model.user.newPasswordConfirmation
      ) {
        return (
          this.model.user.newPassword ===
          this.model.user.newPasswordConfirmation
        );
      }
      return false;
    },
    async handleSubmitChangePassword() {
      this.modals.modalError = "";
      const loader = this.$loading.show({
        container: this.$refs.modal_change_password,
        width: 90,
        height: 90,
      });
      try {
        await api.put(`/users/${this.model.startup.user_id}`, this.model.user);
        this.$toasted.show("Senha atualizada com sucesso");
        this.success = "Alteração de senha realizada com sucesso.";
        this.modals.modalChangePassword = false;
      } catch (e) {
        const strError = "Ocorreu um erro ao atualizar a senha.";
        const hasErrorMessage = e.response && e.response.data;
        this.modals.modalError = hasErrorMessage ? e.response.data : strError;
        this.$toasted.error(strError);
      }
      loader.hide();
    },
  },
  computed: {
    getStartupLogoPath() {
      const defaultLogoPath = "/img/pages/default_logo.png";
      const logo = this.model.startup.logo;
      if (!logo) return defaultLogoPath;
      return logo.url;
    },
  },
};
</script>
<style scoped>
.card-profile-image img {
  width: 180px;
  height: 180px;
  border-radius: 10%;
}

.jump {
  animation: jump 1.5s 0s forwards cubic-bezier(0.84, -0.54, 0.31, 1.19)
    infinite;
}

@keyframes jump {
  0% {
    transform: none;
  }
  50% {
    transform: translateY(-2em);
  }
}
</style>

<style>
.sector_select.v-select {
  background-color: #fff;
  background-clip: padding-box;
  border: none;
  border-radius: 0.375rem;
  font-size: 14px;
}
.sector_select.v-select .vs__dropdown-toggle {
  padding: 6px;
}
.sector_select.v-select .vs__dropdown-toggle .vs__selected-options .vs__search {
  color: #8898aa;
  line-height: 1.5;
  font-weight: 400;
}
</style>
